import React from 'react';
import { useNavigate } from 'react-router-dom';

const s = {
  overlay: {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
    zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: 24, backdropFilter: 'blur(6px)',
    animation: 'fadeIn 0.2s ease'
  },
  modal: {
    background: 'var(--card)', maxWidth: 480, width: '100%',
    borderRadius: 0, overflow: 'hidden', border: '1px solid var(--ink)', boxShadow: '8px 8px 0 rgba(10,10,10,0.12)'
  },
  header: {
    background: 'var(--ink)', padding: '32px 36px 28px'
  },
  eyebrow: {
    fontFamily: 'var(--font-mono)', fontSize: 10, letterSpacing: '3px',
    color: 'var(--muted-2)', textTransform: 'uppercase', marginBottom: 12
  },
  title: {
    fontFamily: 'var(--font-display)', color: 'var(--paper)',
    fontSize: 28, lineHeight: 1.15, marginBottom: 8
  },
  sub: { color: 'var(--muted)', fontSize: 13, lineHeight: 1.6 },
  body: { padding: '28px 36px 32px' },
  features: {
    display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 28
  },
  feature: {
    display: 'flex', alignItems: 'flex-start', gap: 8,
    fontSize: 13, color: 'var(--muted)', lineHeight: 1.4
  },
  dot: {
    width: 6, height: 6, background: 'var(--ink)', borderRadius: '50%',
    flexShrink: 0, marginTop: 5
  },
  primaryBtn: {
    display: 'block', width: '100%',
    background: 'var(--ink)', color: 'var(--paper)', border: 'none',
    padding: '14px', fontSize: 15, fontWeight: 700,
    borderRadius: 0, cursor: 'pointer', letterSpacing: '0.3px',
    marginBottom: 10, textAlign: 'center'
  },
  secondaryBtn: {
    display: 'block', width: '100%',
    background: 'transparent', color: 'var(--ink)',
    border: '1.5px solid var(--ink)',
    padding: '13px', fontSize: 14, fontWeight: 500,
    borderRadius: 0, cursor: 'pointer', textAlign: 'center'
  },
  divider: {
    display: 'flex', alignItems: 'center', gap: 12,
    margin: '0 0 10px', color: 'var(--muted-2)', fontSize: 12
  },
  line: { flex: 1, height: 1, background: 'var(--line-card)' },
  close: {
    position: 'absolute', top: 14, right: 16,
    background: 'transparent', border: 'none',
    color: 'var(--muted-2)', fontSize: 22, cursor: 'pointer', lineHeight: 1,
    zIndex: 1
  }
};

const FEATURES = [
  'Search 574,000+ studies',
  'Advanced filters',
  'Full study details',
  'Save studies',
  'Export results',
  'Email alerts',
];

export default function GuestPromptModal({ onClose }) {
  const navigate = useNavigate();

  return (
    <div style={s.overlay} onClick={e => e.target === e.currentTarget && onClose()}>
      <div style={{ ...s.modal, position: 'relative' }}>
        <button style={s.close} onClick={onClose}>×</button>

        <div style={s.header}>
          <div style={s.eyebrow}>Free Access</div>
          <h2 style={s.title}>Join BioMedArticles to<br />search clinical trials</h2>
          <p style={s.sub}>Create a free account to search and explore 574,000+ studies from ClinicalTrials.gov</p>
        </div>

        <div style={s.body}>
          <div style={s.features}>
            {FEATURES.map((f, i) => (
              <div key={i} style={s.feature}>
                <div style={s.dot} />
                <span>{f}</span>
              </div>
            ))}
          </div>

          <button style={s.primaryBtn} onClick={() => navigate('/register')}>
            Create free account →
          </button>

          <div style={s.divider}><div style={s.line} /><span>or</span><div style={s.line} /></div>

          <button style={s.secondaryBtn} onClick={() => navigate('/login')}>
            Sign in to existing account
          </button>
        </div>
      </div>
    </div>
  );
}